import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VacancyDetailsComponent } from './vacancy-details.component';
const routes: Routes = [
  {
    path: '',
    component: VacancyDetailsComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class vacancyDetailsRoutingoModule { }